import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { auth0Credentials } from '../../../../config';
import { HybridAuthProvider } from './HybdridAuthProvider';

export const Auth0ProviderWithNavigate = ({ children }: any) => {
    const navigate = useNavigate();
    const { domain, clientId } = auth0Credentials;

    const onRedirectCallback = (appState: any) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: `${window.location.origin}/dashboard`,
            }}
            onRedirectCallback={onRedirectCallback}
        >
            <HybridAuthProvider>{children}</HybridAuthProvider>
        </Auth0Provider>
    );
};
